import React from 'react';
import awsBadge from 'static/img/aws.png';
import azBadge from 'static/img/az.png';
import gcpBadge from 'static/img/gcp.png';
import ociBadge from 'static/img/oci.png';

const badgeIcons = {
  AWS: awsBadge,
  AZ: azBadge,
  GCP: gcpBadge,
  OCI: ociBadge,
};

const ChoiceCard = ({ option, isSelected, onSelect, variant = 'checkbox' }) => (
  <button type="button" className={`choice-card choice-card--${variant}${isSelected ? ' is-selected' : ''}`} onClick={onSelect}>
    <span className="choice-card__marker" aria-hidden="true" />
    <span className="choice-card__label">{option.label}</span>
    {option.badge && (
      <span className="choice-card__badge">
        {badgeIcons[option.badge] ? <img src={badgeIcons[option.badge]} alt={`${option.badge} badge`} /> : option.badge}
      </span>
    )}
  </button>
);

export default ChoiceCard;
